import React from 'react';
import { Settings, Globe, Bell, Shield, Database, Mail, Users, Save } from 'lucide-react';

const SettingsPanel = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-foreground">Configuración</h1>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-accent hover:bg-accent/90">
          <Save className="h-4 w-4 mr-2" />
          Guardar Cambios
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <nav className="space-y-1">
            <button className="w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg bg-accent text-white">
              <Globe className="h-5 w-5 mr-3" />
              General
            </button>
            <button className="w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg text-foreground/70 hover:bg-accent/10 hover:text-accent">
              <Bell className="h-5 w-5 mr-3" />
              Notificaciones
            </button>
            <button className="w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg text-foreground/70 hover:bg-accent/10 hover:text-accent">
              <Shield className="h-5 w-5 mr-3" />
              Seguridad
            </button>
            <button className="w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg text-foreground/70 hover:bg-accent/10 hover:text-accent">
              <Database className="h-5 w-5 mr-3" />
              Base de Datos
            </button>
            <button className="w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg text-foreground/70 hover:bg-accent/10 hover:text-accent">
              <Mail className="h-5 w-5 mr-3" />
              Email
            </button>
            <button className="w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg text-foreground/70 hover:bg-accent/10 hover:text-accent">
              <Users className="h-5 w-5 mr-3" />
              Roles y Permisos
            </button>
          </nav>
        </div>

        <div className="lg:col-span-2 space-y-6">
          <div className="dark-card p-6">
            <h2 className="text-lg font-medium text-foreground mb-4">Configuración General</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground/70 mb-1">
                  Nombre de la Plataforma
                </label>
                <input
                  type="text"
                  defaultValue="Cortex AI"
                  className="w-full border border-border rounded-lg bg-secondary/30 px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground/70 mb-1">
                  URL de la Plataforma
                </label>
                <input
                  type="text"
                  defaultValue="https://cortex-ai.es"
                  className="w-full border border-border rounded-lg bg-secondary/30 px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground/70 mb-1">
                  Zona Horaria
                </label>
                <select className="w-full border border-border rounded-lg bg-secondary/30 px-3 py-2">
                  <option>Europe/Madrid (UTC+1)</option>
                  <option>America/New_York (UTC-5)</option>
                  <option>Asia/Tokyo (UTC+9)</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground/70 mb-1">
                  Idioma por Defecto
                </label>
                <select className="w-full border border-border rounded-lg bg-secondary/30 px-3 py-2">
                  <option>Español</option>
                  <option>English</option>
                  <option>Français</option>
                </select>
              </div>
            </div>
          </div>

          <div className="dark-card p-6">
            <h2 className="text-lg font-medium text-foreground mb-4">Mantenimiento</h2>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-foreground">Modo Mantenimiento</h3>
                  <p className="text-sm text-foreground/70">
                    Activa el modo mantenimiento para realizar actualizaciones
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent"></div>
                </label>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-foreground">Depuración</h3>
                  <p className="text-sm text-foreground/70">
                    Habilitar logs de depuración
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent"></div>
                </label>
              </div>
              <div>
                <button className="mt-4 px-4 py-2 border border-red-300 text-red-700 rounded-md hover:bg-red-50">
                  Limpiar Caché
                </button>
              </div>
            </div>
          </div>

          <div className="dark-card p-6">
            <h2 className="text-lg font-medium text-foreground mb-4">Límites del Sistema</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground/70 mb-1">
                  Máximo de Usuarios Concurrentes
                </label>
                <input
                  type="number"
                  defaultValue="1000"
                  className="w-full border border-border rounded-lg bg-secondary/30 px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground/70 mb-1">
                  Tamaño Máximo de Archivo (MB)
                </label>
                <input
                  type="number"
                  defaultValue="10"
                  className="w-full border border-border rounded-lg bg-secondary/30 px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground/70 mb-1">
                  Tiempo Máximo de Sesión (minutos)
                </label>
                <input
                  type="number"
                  defaultValue="120"
                  className="w-full border border-border rounded-lg bg-secondary/30 px-3 py-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;